<template>
    <div v-if="item">
        <div class="hero hero-sm bg-dark">
            <div class="hero-body container grid-xl">
                <div>
                    <figure class="d-inline-block avatar avatar-xl mr-2" style="margin-bottom: 18px">
                        <img :src="image" alt="...">
                    </figure>
                    <h1 class="d-inline-block pl-2 mt-2">{{item.name}}</h1>
                    <h3 class="d-inline-block pl-2 mt-2 text-gray">[{{item.equipment_category}}]</h3>
                </div>
                <p>
                    <span class="chip bg-primary" v-for="p in item.properties">{{p.name}}</span>
                    <span class="chip text-dark" v-if="item.damage && item.damage.damage_type">{{item.damage.damage_type.name}}</span>
                    <span class="chip bg-success" v-if="item['weapon_category:']">{{item['weapon_category:']}}</span>
                    <span class="chip bg-success" v-if="item.gear_category">{{item.gear_category}}</span>
                    <span class="chip bg-success" v-if="item.tool_category">{{item.tool_category}}</span>
                </p>
                <div style="max-width: 50em">
                    <p v-for="des in item.desc">{{des.replace("â€™","'")}}</p>
                </div>
            </div>
        </div>
        <header class="bg-primary py-1">
            <section class="container pt-2 grid-xl">
                <span class="label label-rounded label-warning mr-2 pr-2">{{item.cost.quantity}} {{item.cost.unit}}</span>
                <Stat :value="item.weight">Weight </Stat>
                <Stat v-if="item.weapon_range" :value="item.range.normal">Lower Range </Stat>
                <Stat v-if="item.weapon_range && item.range.long" :value="item.range.long">Upper Range </Stat>
                <Stat v-if="item.armor_class" :value="item.armor_class.base">Base Armor </Stat>
            </section>
        </header>
        <div class="container grid-xl mt-2 py-2 px-2">
            <pre class="code" v-if="raw">
<code>{{JSON.stringify(item, null, 2)}}</code>
</pre>
            <button class="btn btn-primary" @click="raw = !raw">Toggle Raw Data</button>
        </div>
    </div>
</template>
<script>
export default {
    created: function() {
        this.db.collection("items").doc(this.$route.params.id).get().then((doc) => {
            this.item = doc.data();
            this.storage.child(this.item.img).getDownloadURL().then((url) => {
                this.image = url
            })
        })
    },
    data() {
        return {
            hash: decodeURIComponent(window.location.hash.substring(1)),
            item: null,
            image: null,
            raw: false
        }
    }
}
</script>